import './style.scss'
import React from 'react'
import infoIconDefault from 'src/assets/v2/img/info_icon.svg'

export type BannerVariant = 'info' | 'success' | 'warning' | 'error'

export interface InfoBannerProps {
    children: React.ReactNode
    icon?: React.ReactNode
    variant?: BannerVariant
    bgColor?: string
    color?: string
    borderColor?: string
    className?: string
}

const PRESETS: Record<BannerVariant, { bg: string; fg: string; border: string }> = {
    info:    { bg: '#F0F9FF', fg: '#026AA2', border: '#026AA2' },
    success: { bg: '#ECFDF3', fg: '#067647', border: '#ABEFC6' },
    warning: { bg: '#FFFAEB', fg: '#B54708', border: '#FEDF89' },
    error:   { bg: '#FEF3F2', fg: '#B42318', border: '#FECDCA' },
}

export const InfoBanner: React.FC<InfoBannerProps> = ({
                                                          children, icon, variant = 'info', bgColor, color, borderColor, className = '',
                                                      }) => {
    const p = PRESETS[variant]
    return (
        <div
            className={`banner ${className}`}
            style={{
                background: bgColor ?? p.bg,
                color: color ?? p.fg,
                border: `1px solid ${borderColor ?? p.border}`,
                boxShadow: 'none',
            }}
        >
            <span className="banner__icon">{icon ?? <img src={infoIconDefault} alt="" />}</span>
            <span className="banner__text">{children}</span>
        </div>
    )
}

export default InfoBanner